<script lang="tsx">
  import { Skeleton } from "primevue";

  export default {
    components: { Skeleton },
    props: {},
    data() {
      const fields = [];
      for (let i = 0; i < Math.round(Math.random() * 5 + 4); i++) {
        const field = {
          start: true,
          span: 1,
          label: Math.round(Math.random() * 14 + 4),
          height: 1
        };
        if (i >= 2 && fields[i - 1].start && fields[i - 1].span === 1 && Math.random() < 0.5) {
          field.start = false;
        }
        if (i !== 0 && field.start && Math.random() < 0.4) {
          field.span = 2;
        }
        if (i !== 0 && field.span === 2 && Math.random() < 0.3) {
          field.height = Math.round(Math.random() * 2 + 2);
        }
        fields.push(field)
      }

      return { fields };
    },
  };
</script>

<template>
  <section>
    <div class="form">
      <div class="field-grid">
        <div v-for="field in fields"
        :class="{
          'field-row-start': field.start,
          'field-row-end': (!field.start && field.span === 1) || field.span === 2
        }">
          <Skeleton :style="{ width: field.label + 'ch' }"/>
          <Skeleton :style="{ padding: '1em', 'font-size': field.height + 'em' }"/>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="less" scoped>
  .p-skeleton {
    // override prime default of 1rem to emulate font-size
    height: 1em !important;
    margin-block: 0.5rem;
  }

  .field-grid {
    display: grid;
    grid: auto-flow / 1fr 1fr;
    width: 100%;

    margin-block: var(--spacing-block);
    gap: var(--spacing-block);

    align-items: flex-start;
    justify-items: stretch;

    & > .field-row-start { grid-column-start: 1; }
    & > .field-row-end { grid-column-end: -1; }
    & > .field-hidden, & > .field-disabled { display: none; }
  }

  .button-row {
    display: flex;
    justify-content: center;
    margin-block: var(--spacing-block);
  }
</style>
